"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Skew;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// components
function Skew(_ref) {
  var color = _ref.color;
  var textColor = "text-blueGray-100";

  if (color === "white") {
    textColor = "text-white";
  } else if (color === "dark") {
    textColor = "text-blueGray-900";
  }

  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
    className: "w-full pointer-events-none overflow-hidden h-70-px",
    style: {
      transform: "translateZ(0)"
    }
  }, /*#__PURE__*/_react.default.createElement("svg", {
    className: "absolute bottom-0 overflow-hidden",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "none",
    version: "1.1",
    viewBox: "0 0 2560 100",
    x: "0",
    y: "0"
  }, /*#__PURE__*/_react.default.createElement("polygon", {
    className: textColor + " fill-current",
    points: "2560 0 2560 100 0 100"
  }))));
}

Skew.defaultProps = {
  color: "white"
};
Skew.propTypes = {
  color: _propTypes.default.oneOf(["white", "blueGray", "dark"])
};
